/**
 * The use case of a search or ranking request
 *
 * This should be kept in sync with SearchUseCase in website/app/server/services/Listings/graphql/schema.ts
 *
 * @see https://docs.promoted.ai/docs/use-case#enum-values-and-examples for explanations
 */
export enum SearchUseCase {
  SEARCH = "SEARCH",
  RELATED_CONTENT = "RELATED_CONTENT",
  CATEGORY_CONTENT = "CATEGORY_CONTENT",
  DISCOVER = "DISCOVER",
  FEED = "FEED",
  CDP_AS_CLP = "CDP_AS_CLP",
  CUSTOM = "CUSTOM",
  CONTENTFUL = "CONTENTFUL",
  UNKNOWN_USE_CASE = "UNKNOWN_USE_CASE",
}
